import React from 'react';
import { fieldKind } from './constants.js';

// Generic value editor: renders one input per key of the template object and
// emits a fully-formed value object. Keeps K1's {up,down}, P1's {red,green},
// P4's {min,max}, P11's {weeks,style,steps}, etc. all working from one place.
export default function ValueFields({ template, value, onChange }) {
  const keys = Object.keys(template);

  function setField(key, raw) {
    onChange({ ...value, [key]: raw });
  }

  return (
    <div className="value-fields">
      {keys.map((key) => {
        const kind = fieldKind(key, template[key]);
        const current = value?.[key];
        return (
          <label key={key} className="field">
            <span className="field-label">{key}</span>
            {kind === 'number' && (
              <input
                type="number"
                step="any"
                value={current == null ? '' : current}
                onChange={(e) =>
                  setField(key, e.target.value === '' ? null : Number(e.target.value))
                }
              />
            )}
            {kind === 'bool' && (
              <input
                type="checkbox"
                checked={Boolean(current)}
                onChange={(e) => setField(key, e.target.checked)}
              />
            )}
            {kind === 'date' && (
              <input
                type="date"
                value={current == null ? '' : current}
                onChange={(e) => setField(key, e.target.value === '' ? null : e.target.value)}
              />
            )}
            {kind === 'style' && (
              <select value={current ?? 'gradual'} onChange={(e) => setField(key, e.target.value)}>
                <option value="gradual">gradual</option>
                <option value="immediate">immediate</option>
              </select>
            )}
          </label>
        );
      })}
    </div>
  );
}
